import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductInventory extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newInventory = event.detail.data.html.querySelector('product-inventory');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
/* JS para re-render al cambiar variante */
function horizonRenderStoreInventory(container, variantId) {
  const mapRaw = container.getAttribute("data-inv-map") || "{}";
  const threshold = Number(container.getAttribute("data-threshold") || 10);

  let map;
  try { map = JSON.parse(mapRaw); } catch (e) { map = {}; }

  const list = map[String(variantId)] || [];

  // 1) Borrar SOLO las filas anteriores (mantiene el template y data-attrs)
  container.querySelectorAll(".store-inventory__row").forEach(el => el.remove());

  if (!Array.isArray(list) || list.length === 0) return;

  // 2) Tomar el SVG desde el template oculto (siempre disponible)
  const iconTemplate = container.querySelector(".store-inventory__icon-template .product-inventory__icon")?.innerHTML || "";

  // 3) Insertar filas nuevas
  const html = list.map(loc => {
    const qty = Number(loc.qty || 0);

    let status = "out_of_stock";
    if (qty > 0) status = (qty <= threshold) ? "low" : "in_stock";

    return `
      <div class="store-inventory__row store-inventory__row--${status}">
        <span class="store-inventory__status">
          <span class="svg-wrapper product-inventory__icon product-inventory__icon-${status}">
            ${iconTemplate}
          </span>
          <span class="store-inventory__name">${loc.name}</span>
        </span>
        <span class="store-inventory__qty">
          ${qty > 0 ? `${qty} disponibles` : `Agotado`}
        </span>
      </div>
    `;
  }).join("");

  container.insertAdjacentHTML("beforeend", html);
}
// === Listener Horizon: cuando cambia variante, re-renderizamos el stock por sucursal ===
function horizonUpdateStoreInventoryFromVariantEvent(event) {
  // El HTML actualizado viene aquí:
  const newHtml = event?.detail?.data?.html;
  if (!newHtml) return;

  // Tomamos el contenedor NUEVO que viene en el HTML del evento
  const newStore = newHtml.querySelector("[data-inv-map][data-current-variant]");
  if (!newStore) return;

  // Y el contenedor ACTUAL en la página
  const currentStore = document.querySelector("[data-inv-map][data-current-variant]");
  if (!currentStore) return;

  // Copiamos atributos actualizados (mapa + current variant + threshold)
  currentStore.setAttribute("data-inv-map", newStore.getAttribute("data-inv-map") || "{}");
  currentStore.setAttribute("data-current-variant", newStore.getAttribute("data-current-variant") || "");
  currentStore.setAttribute("data-threshold", newStore.getAttribute("data-threshold") || "10");

  // Renderizamos usando la variante actual
  const vid = currentStore.getAttribute("data-current-variant");
  if (vid) horizonRenderStoreInventory(currentStore, vid);
}

// Registramos el listener UNA vez por sección/dialog (igual que ProductInventory)
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".shopify-section, dialog").forEach((scope) => {
    scope.addEventListener(ThemeEvents.variantUpdate, horizonUpdateStoreInventoryFromVariantEvent);
  });
});

/* Termina JS para re-render al cambiar variante */